// Utility to keep highlight tooltip labels inside a given container.
// We use a DOM element (not ::before) so we can measure and flip it when near edges.

/**
 * Flips `.hl-label` to align to the right edge when it would overflow the container on the right.
 *
 * Contract:
 * - `hlEl`: element with class `hl`.
 * - `frameEl`: container element that acts as the positioning frame (typically a segment root).
 */
export function positionHighlightLabelInFrame(hlEl, frameEl) {
    if (!hlEl || !frameEl) return;

    const label = hlEl.querySelector?.('.hl-label');
    if (!label) return;

    // reset to default placement before measuring
    label.classList.remove('hl-label--right');

    const frameRect = frameEl.getBoundingClientRect();
    const labelRect = label.getBoundingClientRect();

    // If it overflows right edge, flip.
    if (labelRect.right > frameRect.right - 4) {
        label.classList.add('hl-label--right');
    }
}

